import { Dot } from "lucide-react";
import React, { useContext, useEffect, useRef, useState } from "react";
import Edit from "../../../../assets/images/icons/editIconNew.svg";
import DocumentViewer from "./DocumentViewer";
import MainServices from "../../../../services/MainServices";
import { notifyWarn } from "../../../../assets/elements/Toast";
import { toast } from "react-toastify";
import { AuthContext } from "../../../../context/AuthContext";
import { Field, FieldArray, Form, Formik } from "formik";
import * as Yup from "yup";
import CustomErrorMessage from "../../../../assets/common/CustomeErrorMessage";
import ButtonLoading from "../../../../assets/loaders/ButtonLoading";
import PDF from "./svg/Pdf";
import dateIcon from "../../../../assets/images/dateIcon.svg";
import useRTLContext from "../../../../hooks/useRTLContext";
import { useTranslation } from "react-i18next";
import EditingRestrictionNotice from "./EditRestrictionNotice";
import { documentValidation } from "../employeesModals/validation";

const IqamaNew = ({
  iqamaDetails,
  personalInfo,
  handleGetTableData,
  empPublicId,
  getEmployeeRegistrationData,
  currentEmployeeEditing = false,
}) => {
  const { isRTL, direction } = useRTLContext();
  const { t, i18n } = useTranslation();
  const [documentViewerOpen, setDocumentViewerOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);
  const [initialValues, setInitialValues] = useState({});

  const [fileNames, setFileNames] = useState({
    frontDocument: iqamaDetails?.frontDocument || "",
    backDocument: iqamaDetails?.backDocument || "",
  });
  const [editingSections, setEditingSections] = useState({
    iqama: false,
    documents: false,
  });
  const [iqamaDetailsError, setIqamaDetailsError] = useState(null);
  const [loading, setLoading] = useState(false);
  const {
    updateIqamaInfo,
    fetchIqamaInfoById,
    fileUpload,
    updateEmployeeRegistrationMaster,
  } = MainServices();

  const handleDocumentChange = (e, setFieldValue) => {
    const { name, files } = e.target;

    if (files && files[0]) {
      const fileData = {
        file: files[0],
        fileName: files[0].name,
      };

      setFileNames((prev) => ({
        ...prev,
        [name]: fileData,
      }));

      const formikField =
        name === "frontDocument" ? "iqamaDocFront" : "iqamaDocBack";
      setFieldValue(formikField, fileData);

      console.log("File uploaded:", files[0].name);
    } else {
      console.log("No file selected");
    }
  };

  const handleRemoveDocument = (documentType, setFieldValue) => {
    setFileNames((prev) => ({
      ...prev,
      [documentType]: "",
    }));

    if (documentType === "frontDocument") {
      fileInputRef1.current.value = "";
      setFieldValue("iqamaDocFront", "");
    } else if (documentType === "backDocument") {
      fileInputRef2.current.value = "";
      setFieldValue("iqamaDocBack", "");
    }
  };

  console.log("fileNames: , ", fileNames);

  const handleViewDocument = (documentUrl, documentType, documentLabel) => {
    setSelectedDocument({
      url: documentUrl,
      type: getFileType(documentUrl),
      label: documentLabel,
    });
    setDocumentViewerOpen(true);
  };

  console.log("iqama details: " + iqamaDetails);

  const getFileType = (url) => {
    try {
      const urlObj = new URL(url); // Ensure it's a valid URL
      const pathname = urlObj.pathname;
      const extension = pathname.split(".").pop().toLowerCase();

      return extension || "unknown"; // Return "unknown" if no extension found
    } catch (error) {
      return "invalid URL"; // Handle invalid URLs
    }
  };

  const handleSubmit = async (values) => {
    const updatedIqamaInfo = {
      ...(values?.iqamaProfession && {
        iqamaProfession: values.iqamaProfession,
      }),
      ...(values?.iqamaId && { iqamaId: values.iqamaId }),
      ...(values?.iqamaIdExpiry && {
        iqamaIdExpiry: values.iqamaIdExpiry,
      }),
      ...(values?.workPermitNo && {
        workPermitNo: values.workPermitNo,
      }),
      ...(values?.workPermitExpiry && {
        workPermitExpiry: values.workPermitExpiry,
      }),
      //   ...(fileNames?.iqamaDocNames?.[0] && {
      //     frontDocument: fileNames.iqamaDocNames[0],
      //   }),
      //   ...(fileNames?.iqamaDocNames?.[1] && {
      //     backDocument: fileNames.iqamaDocNames[1],
      //   }),
    };

    setLoading(true);
    let formattedPersonalInfo = {
      ...(personalInfo?.firstName && { firstName: personalInfo.firstName }),
      ...(personalInfo?.secondName && { secondName: personalInfo.secondName }),
      ...(personalInfo?.thirdName && { thirdName: personalInfo.thirdName }),
      ...(personalInfo?.lastName && { lastName: personalInfo.lastName }),
      ...(personalInfo?.phone && { phone: personalInfo.phone }),
      ...(personalInfo?.email && { email: personalInfo.email }),
      ...(personalInfo?.dobHijri && { dobHijri: personalInfo.dobHijri }),
      ...(personalInfo?.dobGregorian && {
        dobGregorian: personalInfo.dobGregorian,
      }),
      ...(personalInfo?.religion && {
        religion: personalInfo.religion,
      }),
      ...(personalInfo?.maritalStatus && {
        maritalStatus: personalInfo.maritalStatus,
      }),
      ...(personalInfo?.gender && { gender: personalInfo.gender }),
      ...(personalInfo?.citizen && { citizen: personalInfo.citizen }),

      ...(personalInfo?.citizen === "false" &&
        personalInfo?.nationality && {
          nationality: personalInfo?.nationality,
        }),
      ...(personalInfo?.citizen === "true" &&
        personalInfo?.nationalId && {
          nationalId: personalInfo.nationalId,
        }),
    };
    const details = {
      ...(formattedPersonalInfo && formattedPersonalInfo),
      documents: {
        iqamaInfo: updatedIqamaInfo,
      },
    };
    try {
      const response = await updateEmployeeRegistrationMaster(
        details,
        personalInfo?.publicId,
        personalInfo?.concurrencyStamp
      );

      if (response?.data) {
        handleEditToggle("iqama");
        setIqamaDetailsError(null);
        toast("Iqama Details Updated Successfully!", {
          style: { zIndex: 9999 },
        });
        getEmployeeRegistrationData(empPublicId);
        handleGetTableData();
      } else {
        toast.error("Failed to update designation", {
          style: { zIndex: 9999 },
        });
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "An unexpected error occurred",
        {
          style: { zIndex: 9999 },
        }
      );
      console.error("Error", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateDocuments = async () => {
    if (!iqamaDetails?.iqamaId || !iqamaDetails?.iqamaIdExpiry) {
      setIqamaDetailsError(
        "Please complete all required Iqama details before submitting documents"
      );
      return;
    } else {
      setIqamaDetailsError(null);
    }
    const files = [];

    // Add files only if they exist
    if (fileNames?.frontDocument?.file) {
      files.push(fileNames.frontDocument.file);
    }
    if (fileNames?.backDocument?.file) {
      files.push(fileNames.backDocument.file);
    }

    try {
      let updatedFileNames = {};

      // If there are files to upload, call the fileUpload API
      if (files.length > 0) {
        const response = await fileUpload(files);
        if (response?.data) {
          const responseData = response?.data?.data;
          let currentIndex = 0;

          // Handle front document
          if (fileNames?.frontDocument?.file) {
            updatedFileNames.frontDocument =
              responseData[currentIndex]?.fileUrl;
            currentIndex++;
          } else {
            updatedFileNames.frontDocument = fileNames.frontDocument || ""; // Use existing value or empty
          }

          // Handle back document
          if (fileNames?.backDocument?.file) {
            updatedFileNames.backDocument = responseData[currentIndex]?.fileUrl;
          } else {
            updatedFileNames.backDocument = fileNames.backDocument || ""; // Use existing value or empty
          }
        } else {
          throw new Error(response?.message || "Unknown error");
        }
      } else {
        // If no files to upload, directly use the existing fileNames values
        updatedFileNames = {
          frontDocument: fileNames.frontDocument, // Use existing value or empty
          backDocument: fileNames.backDocument, // Use existing value or empty
        };
      }

      // Prepare the personal info object
      let formattedPersonalInfo = {
        ...(personalInfo?.firstName && { firstName: personalInfo.firstName }),
        ...(personalInfo?.secondName && {
          secondName: personalInfo.secondName,
        }),
        ...(personalInfo?.thirdName && { thirdName: personalInfo.thirdName }),
        ...(personalInfo?.lastName && { lastName: personalInfo.lastName }),
        ...(personalInfo?.phone && { phone: personalInfo.phone }),
        ...(personalInfo?.email && { email: personalInfo.email }),
        ...(personalInfo?.dobHijri && { dobHijri: personalInfo.dobHijri }),
        ...(personalInfo?.dobGregorian && {
          dobGregorian: personalInfo.dobGregorian,
        }),
        ...(personalInfo?.religion && { religion: personalInfo.religion }),
        ...(personalInfo?.maritalStatus && {
          maritalStatus: personalInfo.maritalStatus,
        }),
        ...(personalInfo?.gender && { gender: personalInfo.gender }),
        ...(personalInfo?.citizen && { citizen: personalInfo.citizen }),

        ...(personalInfo?.citizen === "false" &&
          personalInfo?.nationality && {
            nationality: personalInfo?.nationality,
          }),
        ...(personalInfo?.citizen === "true" &&
          personalInfo?.nationalId && {
            nationalId: personalInfo.nationalId,
          }),
      };

      // Prepare the updated national ID info
      const updatedIqamaInfo = {
        frontDocument: updatedFileNames.frontDocument,
        backDocument: updatedFileNames.backDocument,
      };

      // Prepare the final payload
      const details = {
        ...(formattedPersonalInfo && formattedPersonalInfo),
        documents: {
          iqamaInfo: updatedIqamaInfo,
        },
      };

      // Call the update API
      const updateResponse = await updateEmployeeRegistrationMaster(
        details,
        personalInfo?.publicId,
        personalInfo?.concurrencyStamp
      );

      if (updateResponse?.data) {
        toast("Iqama Documents Updated Successfully!", {
          style: { zIndex: 999999999999999 },
        });
        getEmployeeRegistrationData(empPublicId);
        handleGetTableData();
        // Toggle back to "Edit" mode
        handleEditToggle("documents");
      }
    } catch (error) {
      console.error("Error updating national ID information:", error);
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
    } finally {
      setLoading(false);
    }
  };

  const getValidationSchema = (section) => {
    const baseSchema = {
      iqamaProfession: Yup.string()
        .required("Iqama Profession is required")
        .trim(),
      iqamaId: Yup.string()
        .required("Iqama ID is required")
        .matches(/^[0-9]{10}$/, "Iqama ID must be a 10-digit number"),
      iqamaIdExpiry: Yup.date()
        .required("Iqama ID Expiry is required")
        .typeError("Invalid date format"),
      workPermitNo: Yup.string()
        .matches(
          /^[\u0660-\u0669\u06F0-\u06F90-9]{5,64}$/,
          "Work Permit Number must contain only digits (min 5, max 64)"
        )
        .required("Work Permit Number is required")
        .trim(),
      workPermitExpiry: Yup.date()
        .required("Work Permit Expiry is required")
        .typeError("Invalid date format"),
    };

    const documentSchema = {
      iqamaDocFront: documentValidation(),
      iqamaDocBack: documentValidation(),
    };

    if (section === "iqama") {
      return Yup.object().shape(baseSchema);
    } else if (section === "documents") {
      return Yup.object().shape(documentSchema);
    } else {
      return Yup.object().shape({});
    }
  };

  const formatDateToYYYYMMDD = (date) => {
    if (!date) return "";

    const isISODate = /^\d{4}-\d{2}-\d{2}T/.test(date);
    const isDDMMYYYY = /^\d{2}\/\d{2}\/\d{4}$/.test(date);
    const isYYYYMMDD = /^\d{4}-\d{2}-\d{2}$/.test(date);

    let formattedDate = "";

    if (isISODate) {
      formattedDate = new Date(date).toISOString().split("T")[0];
    } else if (isDDMMYYYY) {
      const [day, month, year] = date.split("/");
      formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(
        2,
        "0"
      )}`;
    } else if (isYYYYMMDD) {
      formattedDate = date;
    }

    return formattedDate;
  };

  function handleOpenFileInput() {
    fileInputRef1.current.click();
  }

  function handleOpenFileInput2() {
    fileInputRef2.current.click();
  }

  const formatDate = (dateString) => {
    if (!dateString) return ""; // Handle empty values
    const date = new Date(dateString);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const formatDateToDotFormat = (dateString) => {
    if (!dateString) return ""; // Handle empty or invalid input

    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return ""; // Handle empty or undefined values

    const date = new Date(dateString);

    // Convert to YYYY-MM-DD format
    return date.toISOString().split("T")[0];
  };

  const calculateExpiryDays = (dateString) => {
    if (!dateString) return null;
    const expiryDate = new Date(dateString);
    if (isNaN(expiryDate)) return null;
    const diffInMs = expiryDate - new Date();
    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
    return diffInDays > 0 ? `Expiry In ${diffInDays} Days` : "Expired";
  };

  const handleEditToggle = (section, values) => {
    setEditingSections((prev) => {
      const isCurrentlyOpen = prev[section];
      const newState = {
        iqama: false,
        documents: false,
      };

      // If the clicked section was previously closed, open it
      if (!isCurrentlyOpen) {
        newState[section] = true;
      }

      return newState;
    });
  };

  return (
    <>
      <div className="tab-section">
        {/* Iqama Section */}
        <div className="tab-header-container">
          <h3 className="tab-heading">{t("Iqama")}</h3>
          {currentEmployeeEditing ? (
            <>
              <EditingRestrictionNotice message={"Read-only"} />
            </>
          ) : (
            !editingSections.iqama && ( // Show edit button only when not in edit mode
              <div
                className="tab-header-edit-container"
                onClick={() => handleEditToggle("iqama")}
              >
                <img src={Edit} alt="edit icon" />
                <span className="edit-txt">{t("Edit")}</span>
              </div>
            )
          )}
        </div>
        <Formik
          enableReinitialize
          initialValues={{
            iqamaProfession: iqamaDetails?.iqamaProfession || "",
            iqNationality: iqamaDetails?.nationalityInfo
              ? {
                  label: iqamaDetails.nationalityInfo.name,
                  value: iqamaDetails.nationalityInfo.publicId,
                }
              : iqamaDetails?.nationality || null,
            iqamaId: iqamaDetails?.iqamaId || "",
            iqamaIdExpiry: iqamaDetails?.iqamaIdExpiry || null,
            workPermitNo: iqamaDetails?.workPermitNo || "",
            workPermitExpiry: iqamaDetails?.workPermitExpiry || null,
            iqamaNationalityId: iqamaDetails?.nationalityId || "",
            iqamaNationalityIdExpiry: iqamaDetails?.nationalityIdExpiry || "",
            iqamaDocFront: iqamaDetails?.frontDocument || "",
            iqamaDocBack: iqamaDetails?.backDocument || "",
          }}
          validationSchema={
            editingSections.iqama
              ? getValidationSchema("iqama")
              : editingSections.documents
              ? getValidationSchema("documents")
              : undefined
          } // Your validation schema
          onSubmit={(values) => {
            if (editingSections.iqama) {
              handleSubmit(values);
            } else if (editingSections.documents) {
              handleUpdateDocuments(values);
            }
          }}
        >
          {({ values, errors, touched, setFieldValue }) => (
            <Form className="form-section">
              <div className="add-body-content-grid">
                {/* Iqama Profession */}
                <div className="form-group">
                  <div className="add-body-input-section">
                    <div className="add-label-container">
                      <label className="add-label" htmlFor="iqamaProfession">
                        {t("Iqama Profession")}
                      </label>
                      {editingSections.iqama && (
                        <span className="add-req-mark">*</span>
                      )}
                    </div>
                    {editingSections.iqama ? (
                      <input
                        id="iqamaProfession"
                        name="iqamaProfession"
                        className="add-input"
                        placeholder={t("Enter Iqama Profession")}
                        value={values?.iqamaProfession}
                        onChange={(e) =>
                          setFieldValue("iqamaProfession", e.target.value)
                        }
                      />
                    ) : (
                      <div className="display-value">
                        {values.iqamaProfession || t("N/A")}
                      </div>
                    )}
                  </div>
                  {editingSections.iqama && (
                    <CustomErrorMessage
                      name="iqamaProfession"
                      errors={errors}
                      touched={touched}
                    />
                  )}
                </div>

                {/* Iqama ID */}
                <div className="form-group">
                  <div className="add-body-input-section">
                    <div className="add-label-container">
                      <label className="add-label" htmlFor="iqamaId">
                        {t("Iqama ID")}
                      </label>
                      {editingSections.iqama && (
                        <span className="add-req-mark">*</span>
                      )}
                    </div>
                    {editingSections.iqama ? (
                      <input
                        id="iqamaId"
                        name="iqamaId"
                        className="add-wrap-input"
                        placeholder={t("Enter Iqama ID")}
                        value={values?.iqamaId}
                        onChange={(e) =>
                          setFieldValue("iqamaId", e.target.value)
                        }
                      />
                    ) : (
                      <div className="display-value">
                        {values.iqamaId || t("N/A")}
                      </div>
                    )}
                  </div>
                  {editingSections.iqama && (
                    <CustomErrorMessage
                      name="iqamaId"
                      errors={errors}
                      touched={touched}
                    />
                  )}
                </div>

                {/* Iqama ID Expiry */}
                <div className="form-group">
                  <div className="add-body-input-section">
                    <div className="add-label-container">
                      <label className="add-label" htmlFor="iqamaIdExpiry">
                        {t("Iqama ID Expiry")}
                      </label>
                      {editingSections.iqama && (
                        <span className="add-req-mark">*</span>
                      )}
                    </div>
                    {editingSections.iqama ? (
                      <div className="add-input-wrapper">
                        <input
                          type="date"
                          id="iqamaIdExpiry"
                          name="iqamaIdExpiry"
                          className={`add-wrap-input ${
                            !values?.iqamaIdExpiry ||
                            values.iqamaIdExpiry === "dd-mm-yyyy"
                              ? "empty"
                              : ""
                          }`}
                          placeholder="DD/MM/YYYY"
                          value={
                            values?.iqamaIdExpiry
                              ? formatDateToYYYYMMDD(values.iqamaIdExpiry)
                              : ""
                          }
                          onChange={(e) =>
                            setFieldValue("iqamaIdExpiry", e.target.value)
                          }
                        />
                        <img
                          src={dateIcon}
                          alt="date icon"
                          className="add-date-input-in"
                        />
                      </div>
                    ) : (
                      <div className="display-value">
                        {formatDateToYYYYMMDD(values.iqamaIdExpiry) || t("N/A")}
                      </div>
                    )}
                  </div>
                  {editingSections.iqama && (
                    <CustomErrorMessage
                      name="iqamaIdExpiry"
                      errors={errors}
                      touched={touched}
                    />
                  )}
                </div>

                {/* Work Permit No */}
                <div className="form-group">
                  <div className="add-body-input-section">
                    <div className="add-label-container">
                      <label className="add-label" htmlFor="workPermitNo">
                        {t("Work Permit No")}
                      </label>
                      {editingSections.iqama && (
                        <span className="add-req-mark">*</span>
                      )}
                    </div>
                    {editingSections.iqama ? (
                      <input
                        id="workPermitNo"
                        name="workPermitNo"
                        className="add-wrap-input"
                        placeholder={t("Enter Work Permit No")}
                        value={values?.workPermitNo}
                        onChange={(e) =>
                          setFieldValue("workPermitNo", e.target.value)
                        }
                      />
                    ) : (
                      <div className="display-value">
                        {values.workPermitNo || t("N/A")}
                      </div>
                    )}
                  </div>
                  {editingSections.iqama && (
                    <CustomErrorMessage
                      name="workPermitNo"
                      errors={errors}
                      touched={touched}
                    />
                  )}
                </div>

                {/* Work Permit Expiry */}
                <div className="form-group">
                  <div className="add-body-input-section">
                    <div className="add-label-container">
                      <label className="add-label" htmlFor="workPermitExpiry">
                        {t("Work Permit Expiry")}
                      </label>
                      {editingSections.iqama && (
                        <span className="add-req-mark">*</span>
                      )}
                    </div>
                    {editingSections.iqama ? (
                      <div className="add-input-wrapper">
                        <input
                          type="date"
                          id="workPermitExpiry"
                          name="workPermitExpiry"
                          className={`add-wrap-input ${
                            !values?.workPermitExpiry ||
                            values.workPermitExpiry === "dd-mm-yyyy"
                              ? "empty"
                              : ""
                          }`}
                          placeholder="DD/MM/YYYY"
                          value={
                            values?.workPermitExpiry
                              ? formatDateToYYYYMMDD(values.workPermitExpiry)
                              : ""
                          }
                          onChange={(e) =>
                            setFieldValue("workPermitExpiry", e.target.value)
                          }
                        />
                        <img
                          src={dateIcon}
                          alt="date icon"
                          className="add-date-input-in"
                        />
                      </div>
                    ) : (
                      <div className="display-value">
                        {formatDateToYYYYMMDD(values.workPermitExpiry) ||
                          t("N/A")}
                      </div>
                    )}
                  </div>
                  {editingSections.iqama && (
                    <CustomErrorMessage
                      name="workPermitExpiry"
                      errors={errors}
                      touched={touched}
                    />
                  )}
                </div>
              </div>

              {/* Submit button for Iqama section (only visible in edit mode) */}
              {editingSections.iqama && (
                <div className="add-footer">
                  <span></span>
                  <div className="add-footer-right">
                    <button
                      type="button"
                      className="add-footer-cancel-btn"
                      onClick={() => handleEditToggle("iqama")}
                    >
                      {t("Cancel")}
                    </button>
                    <button
                      type="submit"
                      className="add-footer-submit-btn"
                      disabled={loading}
                    >
                      {loading ? <ButtonLoading /> : t("Submit")}
                    </button>
                  </div>
                </div>
              )}

              {/* Documents Section Header */}
              <div className="tab-header-container">
                <h3 className="tab-heading">{t("Documents")}</h3>
                {currentEmployeeEditing ? (
                  <EditingRestrictionNotice message="View-only" />
                ) : (
                  !editingSections.documents && ( // Show edit button only when not in edit mode
                    <div
                      className="tab-header-edit-container"
                      onClick={() => handleEditToggle("documents")}
                    >
                      <img src={Edit} alt="edit icon" />
                      <span className="edit-txt">{t("Edit")}</span>
                    </div>
                  )
                )}
              </div>

              {/* Documents Section Body */}
              {editingSections.documents ? (
                // Editing Mode
                <div className="upload-body-tab">
                  {iqamaDetailsError && (
                    <div className="details-error">{iqamaDetailsError}</div>
                  )}
                  {/* Front Document */}
                  <div className="upload-file-input-container m-0">
                    <div className="upload-file-input-container2">
                      <div className="upload-label-container">
                        <label htmlFor="iqamaDocFront" className="upload-label">
                          {t("Front Document")}
                        </label>
                        <span className="upload-req-mark">*</span>
                      </div>
                      <div className="remove-btn-wrapper">
                        <div
                          className="upload-file-input-wrapper"
                          onClick={handleOpenFileInput}
                        >
                          <span className="upload-file-input-replacer">
                            {fileNames.frontDocument.fileName ||
                              fileNames?.frontDocument ||
                              t("No Document")}
                          </span>
                          <input
                            name="frontDocument" // Use "frontDocument" as the name
                            ref={fileInputRef1}
                            id="iqamaDocFront"
                            type="file"
                            className="upload-file-hidden-input"
                            onChange={(e) =>
                              handleDocumentChange(e, setFieldValue)
                            } // Use the updated handler
                          />
                          <button type="button" className="upload-btn">
                            {t("Upload File")}
                          </button>
                        </div>
                        {fileNames?.frontDocument && (
                          <button
                            type="button"
                            className="remove-file-btn-national"
                            onClick={() =>
                              handleRemoveDocument(
                                "frontDocument",
                                setFieldValue
                              )
                            }
                          >
                            {t("Remove")}
                          </button>
                        )}
                      </div>
                    </div>
                    <CustomErrorMessage
                      name="iqamaDocFront"
                      errors={errors}
                      touched={touched}
                    />
                  </div>

                  {/* Back Document */}
                  <div className="upload-file-input-container m-0">
                    <div className="upload-file-input-container2">
                      <div className="upload-label-container">
                        <label htmlFor="iqamaDocBack" className="upload-label">
                          {t("Back Document")}
                        </label>
                        <span className="upload-req-mark">*</span>
                      </div>
                      <div className="remove-btn-wrapper">
                        <div
                          className="upload-file-input-wrapper"
                          onClick={handleOpenFileInput2}
                        >
                          <span className="upload-file-input-replacer">
                            {fileNames.backDocument.fileName ||
                              fileNames?.backDocument ||
                              t("No Document")}
                          </span>
                          <input
                            name="backDocument" // Use "backDocument" as the name
                            ref={fileInputRef2}
                            id="iqamaDocBack"
                            type="file"
                            className="upload-file-hidden-input"
                            onChange={(e) =>
                              handleDocumentChange(e, setFieldValue)
                            } // Use the updated handler
                          />
                          <button type="button" className="upload-btn">
                            {t("Upload File")}
                          </button>
                        </div>
                        {fileNames?.backDocument && (
                          <button
                            type="button"
                            className="remove-file-btn-national"
                            onClick={() =>
                              handleRemoveDocument(
                                "backDocument",
                                setFieldValue
                              )
                            } // Pass the document type
                          >
                            {t("Remove")}
                          </button>
                        )}
                      </div>
                    </div>
                    <CustomErrorMessage
                      name="iqamaDocBack"
                      errors={errors}
                      touched={touched}
                    />
                  </div>
                </div>
              ) : (
                // Non-Editing Mode
                <div className="upload-body-tab">
                  {/* Front Document */}
                  <div className="upload-file-input-container-tab">
                    <div className="upload-file-input-container2">
                      <div className="upload-label-container">
                        <label htmlFor="iqamaDocFront" className="upload-label">
                          {t("Front Document")}
                        </label>
                      </div>
                      <div className="document-display-container-tab">
                        <div className="document-info-tab">
                          <PDF /> {/* PDF icon */}
                          <span className="document-name-tab">
                            {values.iqamaDocFront
                              ? t("Front Document")
                              : t("No Document Uploaded")}
                          </span>
                        </div>
                        {values.iqamaDocFront && (
                          <button
                            type="button"
                            className="view-document-btn-tab"
                            onClick={() =>
                              handleViewDocument(
                                values.iqamaDocFront,
                                "Front Document",
                                "Iqama Front"
                              )
                            }
                          >
                            {t("View")}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Back Document */}
                  <div className="upload-file-input-container-tab">
                    <div className="upload-file-input-container2">
                      <div className="upload-label-container">
                        <label htmlFor="iqamaDocBack" className="upload-label">
                          {t("Back Document")}
                        </label>
                      </div>
                      <div className="document-display-container-tab">
                        <div className="document-info-tab">
                          <PDF /> {/* PDF icon */}
                          <span className="document-name-tab">
                            {values.iqamaDocBack
                              ? t("Back Document")
                              : t("No Document Uploaded")}
                          </span>
                        </div>
                        {values.iqamaDocBack && (
                          <button
                            type="button"
                            className="view-document-btn-tab"
                            onClick={() =>
                              handleViewDocument(
                                values.iqamaDocBack,
                                "Back Document",
                                "Iqama Back"
                              )
                            }
                          >
                            {t("View")}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Submit button for Documents section (only visible in edit mode) */}
              {editingSections.documents && (
                <div className="add-footer">
                  <span></span>
                  <div className="add-footer-right">
                    <button
                      type="button"
                      className="add-footer-cancel-btn"
                      onClick={() => handleEditToggle("documents")}
                    >
                      {t("Cancel")}
                    </button>
                    <button
                      type="submit"
                      className="add-footer-submit-btn"
                      disabled={loading}
                    >
                      {loading ? <ButtonLoading /> : t("Submit")}
                    </button>
                  </div>
                </div>
              )}
            </Form>
          )}
        </Formik>
      </div>

      <DocumentViewer
        isOpen={documentViewerOpen}
        onClose={() => setDocumentViewerOpen(false)}
        documentUrl={selectedDocument?.url}
        documentType={selectedDocument?.type}
        documentLabel={selectedDocument?.label}
      />
    </>
  );
};

export default IqamaNew;
